import React, { useState } from 'react'
import { Collapse } from '@paintscout/ui'
import classNames from 'classnames'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import type { PainterWorkItem } from './types'
import { handleKeyboardAction } from './keyboard'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'

interface WorkItemRowProps {
  item: PainterWorkItem
  showHours: boolean
  classes: ReturnType<typeof usePainterWorkOrderStyles>
}

export default function WorkItemRow({ item, showHours, classes }: WorkItemRowProps) {
  const [expanded, setExpanded] = useState(false)
  const hasSubareas = item.subareas && item.subareas.length > 0
  const isExpandable = hasSubareas || !!item.description
  return (
    <>
      <div
        className={classNames(classes.summaryRow, {
          [classes.summaryRowExpanded]: expanded,
          [classes.summaryRowCollapsed]: !expanded,
          [classes.summaryRowStatic]: !isExpandable
        })}
        onClick={() => isExpandable && setExpanded((v) => !v)}
        role={isExpandable ? 'button' : undefined}
        tabIndex={isExpandable ? 0 : undefined}
        onKeyDown={(event) => isExpandable && handleKeyboardAction(event, () => setExpanded((v) => !v))}
      >
        <span className={classes.summaryRowLabel}>{item.name}</span>
        <div className={classes.summaryRowValue}>
          {showHours && item.hours != null && <span className={classes.summaryRowValueText}>{item.hours} hr</span>}
          {isExpandable &&
            (expanded ? (
              <KeyboardArrowUpIcon className={classes.summaryRowIcon} />
            ) : (
              <KeyboardArrowDownIcon className={classes.summaryRowIcon} />
            ))}
        </div>
      </div>
      <Collapse show={expanded}>
        <div className={classes.summaryRowContent}>
          {item.description && (
            <div className={classes.workSubareaCard}>
              <div className={classes.workSubareaCardHeader}>
                <div className={classes.workSubareaName}>Area Description</div>
              </div>
              <div className={classes.workSubareaDetail} dangerouslySetInnerHTML={{ __html: item.description }} />
            </div>
          )}
          {hasSubareas &&
            item.subareas!.map((sub, index) => (
              <div key={index} className={classes.workSubareaCard}>
                <div className={classes.workSubareaCardHeader}>
                  <div className={classes.workSubareaName}>
                    {sub.name ?? 'Subarea'}
                    {showHours && sub.hours != null && ` - ${sub.hours} hr`}
                  </div>
                </div>
                {sub.description && (
                  <div className={classes.workSubareaDetail} dangerouslySetInnerHTML={{ __html: sub.description }} />
                )}
                {sub.crewNote && (
                  <div className={classes.workSubareaDetail} dangerouslySetInnerHTML={{ __html: sub.crewNote }} />
                )}
                {sub.coats != null && sub.coats > 0 && (
                  <div className={classes.workSubareaDetail}>{`Coats: ${sub.coats}`}</div>
                )}
                {sub.reportText && (
                  <div className={classes.workSubareaDetail} dangerouslySetInnerHTML={{ __html: sub.reportText }} />
                )}
              </div>
            ))}
        </div>
      </Collapse>
    </>
  )
}
